module.exports = __webpack_public_path__ + "static/media/7import-14.9b70bf0b.xlsx";